import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard, Pagination, Thumbs, FreeMode, Swiper as SwiperClass } from 'swiper';
import 'swiper/css/bundle';
import FullscreenImageSlider from '../FullscreenImageSlider/FullscreenImageSlider';
import { useMemo } from 'react';
import SliderImage from '../../Types/SliderImage';
import { StyledSwiper } from './Styles/ProductPage.ImageSliderStyling';
import { useTypedSelector } from "../../Hooks/useTypedSelector";

interface ProductPageImageSliderProps {
  images: SliderImage[];
}

const THUMBNAILS_PER_VIEW = 8;

const ProductPageImageSlider = ({ images }: ProductPageImageSliderProps) => {
  const [swiperInstance, setSwiperInstance] = useState<SwiperClass>();
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | undefined>();
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [rendered, setRendered] = useState(false);
  const imageCount = useMemo(() => images.length, [images]);
  useEffect(() => setRendered(true), []);

  const {
    articleNumber
  } = useTypedSelector((state) => state.buyButton);

  useEffect(() => {
    var imageIndex = images.findIndex(x => x.articleNumber === articleNumber);
    if (imageIndex !== -1) {
      swiperInstance?.slideTo(imageIndex + 1, 0, false);
    }

  }, [articleNumber]);

  return (
    <StyledSwiper>
      {!rendered && images?.length > 0 && (
        <div className="mainSwiper-Placeholder">
          <img
            className="image"
            style={{ margin: 'auto' }}
            src={images[0]?.src}
            alt={images[0]?.alt}
          />
        </div>
      )}
      {rendered && (
        <>
          <Swiper
            onSwiper={setSwiperInstance}
            navigation={true}
            spaceBetween={1}
            pagination={{
              dynamicBullets: imageCount > 8 ? true : false,
              dynamicMainBullets: 3,
            }}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[Navigation, FreeMode, Pagination, Thumbs, Keyboard]}
            lazy={true}
            loop={true}
            keyboard={true}
            slidesPerView={1}
            className="mainSwiper"
            onSlideChange={(swiper) => setActiveSlideIndex(swiper.realIndex)}
          >
            {images.map((image, index) => (
              <SwiperSlide
                key={image.src + index}
                onClick={() => setFullscreenOpen(true)}
              >
                <div>
                  <img className="image" src={image.src} alt={image.alt} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={THUMBNAILS_PER_VIEW}
            watchSlidesProgress={true}
            slidesPerView={
              imageCount > THUMBNAILS_PER_VIEW
                ? THUMBNAILS_PER_VIEW
                : imageCount
            }
            slidesPerGroup={
              imageCount > THUMBNAILS_PER_VIEW
                ? THUMBNAILS_PER_VIEW
                : imageCount
            }
            modules={[FreeMode, Thumbs, Keyboard]}
            keyboard={true}
            className="thumbnail-swiper"
          >
            {images.map((image, index) => (
              <SwiperSlide
                className="thumbnail-slide"
                key={image.thumbnailSrc + index}
              >
                <div>
                  <img
                    className="thumbnail-image"
                    src={image.thumbnailSrc}
                    alt={image.alt}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
      {fullscreenOpen && (
        <FullscreenImageSlider
          images={images}
          onClosed={() => setFullscreenOpen(false)}
          initialSlide={activeSlideIndex}
        />
      )}
    </StyledSwiper>
  );
};

export default ProductPageImageSlider;
